import * as R from "ramda";

import { courseUnitViews, fullCourseViews } from "../../../../utils/courseViews";
import {
  CourseComponentTag,
  CourseInstructionType,
  CourseUnitView,
  ICourseComponent,
  ICourseInstruction,
  ICourseUnit,
  IFullCourse,
} from "../../../course-author/types";

const emptyGroups = {
  [CourseInstructionType.Introduction]: [],
  [CourseInstructionType.Lesson]: [],
  [CourseInstructionType.Summary]: [],
  [CourseInstructionType.Appendix]: [],
};

export function instructions(
  unit: ICourseUnit
): {
  [idx in CourseInstructionType]: ICourseInstruction[];
} {
  const currentinstructions = R.filter(
    (comp: ICourseComponent) => comp.tag === CourseComponentTag.Instruction && !comp.deleted,
    courseUnitViews.components(unit) || []
  ) as ICourseInstruction[];

  return {
    ...emptyGroups,
    ...R.groupBy<ICourseInstruction>(instr => instr.content.type, currentinstructions),
  };
}

export function tailUnit(course: IFullCourse, unitPath: CourseUnitView[]): ICourseUnit | null {
  const unitView = R.last(unitPath);
  if (R.isNil(unitView)) {
    return null;
  }
  return unitView(course);
}

export function componentIndex(
  course: IFullCourse,
  unitPath: CourseUnitView[],
  component: ICourseComponent
): number | null {
  const parentUnitView = R.last(unitPath);

  if (R.isNil(parentUnitView)) {
    return R.indexOf(component, fullCourseViews.units(course) || []);
  }

  return R.indexOf(component, courseUnitViews.components(parentUnitView(course)) || []);
}
